import React from 'react'
import rightArrow from '../Pagination/icon-right-arrow.svg'
import leftArrow from '../Pagination/icon-left-arrow.svg'

const AppHomePagination = ({ data, page, onSelect }) => {
  const pageNum = Number(page) || 1
  return (
    <>
      <div className="pagination-button">
        {pageNum > 1 && (
          <a onClick={() => onSelect(pageNum - 1)}>
            <img className="navigation-icon" src={leftArrow} alt="Previous" />
          </a>
        )}
        <span className="pageNo">{pageNum}</span>
        {data.pagination?.lastEvaluatedSK && (
          <a onClick={() => onSelect(pageNum + 1)}>
            <img className="navigation-icon" src={rightArrow} alt="Next" />
          </a>
        )}
      </div>
    </>
  )
}
export default AppHomePagination
